interface Props {
  // any tracking params that are missing from the query parameters of the redirect url; displays a warning message on the interstitial page when the redirect is suppressed (non-prod environments only)
  missingTrackingParams: string[];
}

const MissingTrackingParamsComponent: React.FC<Props> = ({
  missingTrackingParams,
}) => {
  return (
    <>
      {missingTrackingParams.length > 0 && (
        <div>
          <p style={{ textDecoration: 'underline', color: 'black' }}>
            Append the `suppress` query parameter to stay on this page and view
            the following error.
            <br />
            This message should only be displayed in stage.
          </p>
          <br />
          <b style={{ fontSize: '18px' }}>ERROR</b>
          <br />
          <br />
          <b>The following tracking query params are missing:</b>
          <p>{missingTrackingParams.join(', ')}</p>
          <br />
          <p>
            Click&nbsp;
            <a href="https://github.com/NerdWallet/interstitial-client-next/blob/main/app/server/lib/types/request.ts#L5-L16">
              here
            </a>
            &nbsp;for more information.
          </p>
        </div>
      )}
    </>
  );
};

export default MissingTrackingParamsComponent;
